export default __webpack_public_path__ + "static/anchoring_pens-da556c625f0e58c5dada8aa2f1268303.jpg";